import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../shared/api.service';
import { Router,ActivatedRoute } from '@angular/router';
import { NbAuthJWTToken,NbAuthService } from '@nebular/auth';
@Component({
  selector: 'ngx-admin-otp',
  templateUrl: './admin-otp.component.html',
  styleUrls: ['./admin-otp.component.scss']
})
export class AdminOtpComponent {
  otp: any;
  alert: any;
  alertflag: number;
  user_id: any;
  enterOtp:any;
  otpValidation: boolean;
  email:any;
  resendcount:number = 0;
  resendmessage:boolean =false;
  constructor(private router : Router,
    private route : ActivatedRoute,
    protected api : ApiService,
    private authService : NbAuthService) {
      this.authService.onTokenChange()
        .subscribe((token: NbAuthJWTToken) => {
        // if(token.getPayload()['role'] !="admin"){
        //   this.router.navigate(['auth/logout'])
        // }
        if(token.getPayload()['role'] =="admin" || token.getPayload()['role'] =="sub-admin"){
        }else{
          this.router.navigate(['auth/logout'])
        }
      });
    }

  ngOnInit() {
    this.email = localStorage.getItem('email');
    // this.api.sendOtp().subscribe(data=>{
    //   if(data['status'] == 200){
    //     this.otp = data['data']
    //   }
    // })
    this.reSendOtp()
  }

  cancel(){
    localStorage.clear()
    this.router.navigate(['auth/logout']);
  }

  reSendOtp() {
    this.resendcount++;
    try {

      this.api.updateAndGetOtp(this.email).subscribe(
        (response: any) => {
          if (response['status'] === 200) {
            console.log('OTP sent successfully!');
            this.resendmessage = true;
            setTimeout(() => {
              this.resendmessage = false;
            }, 2000)
          } else {
            console.log('Failed to send Otp.');
          }
        },
        (error: any) => {
          console.log(error);
        }
      );
    } catch (error) {
      console.log('Error generating OTP:', error);
    }
  }

  checkOtp() {
    this.api.verifyOtp(this.email, this.otp).subscribe(
      (response: any) => {
        if (response['status'] === 200) {
          var token;
          this.authService.getToken().subscribe((result) => {
            token = result.getValue();
          });
          this.authService.refreshToken('email', { "token": token }).subscribe((result) => {


            this.router.navigate(['pages/help']);
          });
        } else {
          console.log('Wrong Otp Please Check')

        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  verify() {
    this.enterOtp = (document.getElementById('enterOtp') as HTMLInputElement).value;
    this.api.updateOtp(this.enterOtp).subscribe(data => {
      if (data['status'] == 200) {
        var token ;
         this.authService.getToken().subscribe((result) => {
          token = result.getValue();
        });        
        this.authService.refreshToken('email',{"token":token}).subscribe((result) => { 
          
          
          this.router.navigate(['pages/help']);
        });
        
      }else{
        this.otpValidation = false;
      }
    });
  }
  resendOtp(){
    
    this.api.sendOtp().subscribe(data=>{
      if(data['status'] == 200){
        
        this.otp = data['data']
        
      }
    })
  }
}
